import { RESET_PASSWORD } from './index';
import { Action } from '../action';
import { ResetPasswordForm } from '@shared/core';

export class ResetPasswordInitAction implements Action {
	readonly type = RESET_PASSWORD.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class ResetPasswordDestroyAction implements Action {
	readonly type = RESET_PASSWORD.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class ResetPasswordClickSubmitAction implements Action {
	readonly type = RESET_PASSWORD.CLICK_SUBMIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class ResetPasswordClickLoginAction implements Action {
	readonly type = RESET_PASSWORD.CLICK_LOGIN;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class ResetPasswordFormUpdateAction implements Action {
	readonly type = RESET_PASSWORD.FORM_UPDATE;
	constructor(
		public payload: ResetPasswordForm,
		public correlationId?: number
	) {}
}

export class ResetPasswordFormResetAction implements Action {
	readonly type = RESET_PASSWORD.FORM_RESET;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}
